import React from "react";
import { Box, Grid, Typography } from "@mui/material";

export default function ListaCondiciones({ items }) {
    const colors = ["#f5f5f5", "#e0f7fa"]; // color1, color2

    return (
        <Grid 
            container 
            size={{xs: 12, sm: 12, md: 12}} 
            sx={{
                border: '0.5px solid gray',
                mt: 3
            }}
        >
            {items.map((text, index) => (
                <Box
                    key={index}
                    sx={{
                        bgcolor: colors[index % 2], // alterna entre los dos colores
                        border: '0.5px solid gray',
                        borderRadius: 1,
                        p: 2,
                        width: "100%",
                        fontSize: 'small'
                    }}
                >
                    <Typography variant="body3">{text}</Typography>
                </Box>
            ))}
        </Grid>
    );
}
